import React from 'react';
import SectionTitle from '../SectionTitle';

/**
 * Секція внутрішньої сторінки: підпис, заголовок, за потреби абзац і
 * посилання праворуч — і вміст під ними.
 *
 * Відступ між секціями задається тут, а не кожною сторінкою своїм mb-10,
 * mb-12 чи space-y-14: саме з таких розбіжностей і складалося відчуття, що
 * сторінки верстали різні люди. Відступ стоїть зверху й зникає в першої
 * секції контейнера, тож секції можна просто ставити одна за одною.
 *
 * `id` лягає на саму секцію — туди ведуть посилання змісту (#zagalni), і
 * scroll-mt не дає заголовку сховатися під фіксованим меню. Заголовок
 * отримує `${id}-title`, і секція називається ним для екранного диктора.
 *
 * `captionTone="amber"` — бурштиновий підпис для блоків-попереджень.
 */
const PageSection = ({
  id,
  caption,
  captionTone,
  title,
  description,
  link,
  headingAs = 'h2',
  as: Tag = 'section',
  spacing = 'mt-14 lg:mt-20 first:mt-0',
  className = '',
  children
}) => {
  const headingId = id && title ? `${id}-title` : undefined;
  return (
    <Tag id={id} aria-labelledby={headingId} className={`scroll-mt-28 ${spacing} ${className}`}>
      {title && (
        <SectionTitle
          id={headingId}
          as={headingAs}
          caption={caption}
          captionTone={captionTone}
          title={title}
          description={description}
          link={link}
        />
      )}
      {children}
    </Tag>
  );
};

export default PageSection;
